var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 56,
    viewBox: "0 0 64 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_56)",
    filter: "url(#filter0_d_2_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4444 16.4444H19.5556C18.6126 16.4444 17.7082 16.819 17.0414 17.4858C16.3746 18.1526 16 19.057 16 20V36C16 36.943 16.3746 37.8474 17.0414 38.5142C17.7082 39.181 18.6126 39.5556 19.5556 39.5556H44.4444C45.3874 39.5556 46.2918 39.181 46.9586 38.5142C47.6254 37.8474 48 36.943 48 36V20C48 19.057 47.6254 18.1526 46.9586 17.4858C46.2918 16.819 45.3874 16.4444 44.4444 16.4444Z",
    fill: "#003399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.479 20.6267L33.2337 20.0782H32.3012L32.0123 19.1911L31.7243 20.0782H30.7919L31.5466 20.6267L31.2577 21.5138L32.0123 20.9653L32.767 21.5138L32.479 20.6267ZM32.479 36.0338L33.2337 35.4853H32.3012L32.0123 34.5982L31.7243 35.4853H30.7919L31.5466 36.0338L31.2577 36.9209L32.0123 36.3724L32.767 36.9209L32.479 36.0338ZM24.7759 28.3298L25.5306 27.7813H24.5972L24.3092 26.8942L24.0203 27.7813H23.0879L23.8426 28.3298L23.5546 29.2169L24.3092 28.6684L25.0639 29.2169L24.7759 28.3298ZM25.7599 24.5209L26.5146 23.9724H25.5812L25.2932 23.0853L25.0052 23.9724H24.0719L24.8266 24.5209L24.5386 25.408L25.2932 24.8596L26.0479 25.408L25.7599 24.5209ZM25.7599 32.1822L26.5146 31.6338H25.5812L25.2932 30.7467L25.0052 31.6338H24.0719L24.8266 32.1822L24.5386 33.0693L25.2932 32.5209L26.0479 33.0693L25.7599 32.1822ZM28.6274 21.6587L29.3821 21.1102H28.4488L28.1608 20.2231L27.8728 21.1102H26.9394L27.6941 21.6587L27.4061 22.5458L28.1608 21.9973L28.9154 22.5458L28.6274 21.6587ZM28.6274 35.0516L29.3821 34.5031H28.4488L28.1608 33.616L27.8728 34.5031H26.9394L27.6941 35.0516L27.4061 35.9387L28.1608 35.3911L28.9154 35.9387L28.6274 35.0516ZM39.2239 28.3298L38.4692 27.7813H39.4026L39.6906 26.8942L39.9794 27.7813H40.9119L40.1572 28.3298L40.4452 29.2169L39.6906 28.6684L38.9359 29.2169L39.2239 28.3298ZM38.2399 24.5209L37.4852 23.9724H38.4186L38.7066 23.0853L38.9946 23.9724H39.9279L39.1732 24.5209L39.4612 25.408L38.7066 24.8596L37.9519 25.408L38.2399 24.5209ZM38.2399 32.1822L37.4852 31.6338H38.4186L38.7066 30.7467L38.9946 31.6338H39.9279L39.1732 32.1822L39.4612 33.0693L38.7066 32.5209L37.9519 33.0693L38.2399 32.1822ZM35.3723 21.6587L34.6177 21.1102H35.551L35.839 20.2231L36.127 21.1102H37.0603L36.3057 21.6587L36.5937 22.5458L35.839 21.9973L35.0843 22.5458L35.3723 21.6587ZM35.3723 35.0516L34.6177 34.5031H35.551L35.839 33.616L36.127 34.5031H37.0603L36.3057 35.0516L36.5937 35.9387L35.839 35.3911L35.0843 35.9387L35.3723 35.0516Z",
    fill: "#FFCC00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_56",
    x: 0,
    y: 0,
    width: 64,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.768506 0 0 0 0 0.768506 0 0 0 0 0.768506 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_56"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_56",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuFlag);
export default __webpack_public_path__ + "static/media/eu-flag.e3c8ddfb2ca72536cbdb5bd381ba9fa2.svg";
export { ForwardRef as ReactComponent };